export enum OrderStatus {
  SUBMITTED = 0,
  PAID = 1,
  COMPLETED = 2,
  CANCELED = 3,
}
